// Fetch list

export const FETCH = 'customerAddressTypes.FETCH'
export const FETCH_STARTED = 'customerAddressTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'customerAddressTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'customerAddressTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'customerAddressTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'customerAddressTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'customerAddressTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'customerAddressTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'customerAddressTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'customerAddressTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'customerAddressTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'customerAddressTypes.SAVE'
export const SAVE_STARTED = 'customerAddressTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'customerAddressTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'customerAddressTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'customerAddressTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'customerAddressTypes.DELETE'
export const DELETE_STARTED = 'customerAddressTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'customerAddressTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'customerAddressTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'customerAddressTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'customerAddressTypes.EXPORT'
export const EXPORT_FULFILLED = 'customerAddressTypes.EXPORT_FULFILLED'
